import MlbAllTeams from "@/services/MlbAllTeam";
import common from "@/services/common.js";
import axios from "axios";
import _ from "lodash";
import { SocketInstance } from "@/main";

const state = () => ({
  Teams: [],
  injuries: [],
  depthChart: [],
  upcomingGames: [],
  cloneTeam: [],
  operator: "",
  position: "",
  operatorGameType: "",
  playersDetail: [],
  loadingStatus: false,
  getTeamStatus: false,
  teamBuildStatus: false,
  topPlaysStatus: false,
  mlbplayerDetailLoader: false,
  AllSlate: [],
  buildTeam: [],
  TeamStack: [],
  savedLineup: [],
  LineupBuild: [],
  // playerInfo: [],
  teamInfo: [],
  playerReset: [],
  playerPerTeam: "",
  exposure: [],
  topPlayers: [],
  setTopPlaysData: [],
  premiumFilterList: [],
  TopStudAndValues: [],
  playerTrends: [],
  playerSwap: [],
  fullStats: [],
  scoring: [],
  status: true,
  lastLineup: [],
  mlb_props: [],
  mlb_adp: [],
  daily_lineups: [],
  mlbNews: [],
});

const mutations = {
  SET_EXPOSURE(state, data) {
    if (state.operator == "FanDuel" && state.operatorGameType == "Single") {
      state.exposure.push(data);
      //console.log('exposure mlb Fd', state.exposure);
    } else {
      state.exposure.push(data);
      //console.log('exposure mlb', state.exposure);
    }
  },

  REMOVE_EXPOSURE(state) {
    state.exposure = [];
    //console.log('exposure remove mlb', state.exposure);
  },

  SET_TOP_PLAYS(state, data) {
    state.setTopPlaysData = data;
    //console.log('top plays: ', state.setTopPlaysData);
  },

  SHOW_TOP_PLAYS(state, data) {
    state.topPlayers = data;
  },

  SHOW_PREMIUM_FILTER(state, data) {
    state.premiumFilterList = data;
  },

  SET_TEAMS(state, teams) {
    state.Teams = teams;
    // state.newArryTeam.push(...state.Teams);
    //console.log('teams mlb', state.Teams);
  },

  SET_INJURIES(state, data) {
    state.injuries = data;
  },

  SET_DEPTHCHART(state, data) {
    state.depthChart = data;
  },

  SET_UPCOMINGGAMES(state, data) {
    state.upcomingGames = data;
  },

  SET_CLONE(state, clone) {
    state.cloneTeam = { ...clone };
    // state.newArrayClone.push(...state.cloneTeam);
    //console.log('clone teams mlb', state.cloneTeam);
  },

  SET_LOADING(state, newLoadingStatus) {
    state.loadingStatus = newLoadingStatus;
  },

  SET_PLAYERDETAIL_LOADER(state, loader) {
    state.mlbplayerDetailLoader = loader;
  },

  SET_TEAM_LOADER(state, loader) {
    state.getTeamStatus = loader;
  },

  SET_BUILD_TEAM_LOADER(state, status) {
    state.teamBuildStatus = status;
  },

  SET_TOP_PLAYS_LOADER(state, status) {
    state.topPlaysStatus = status;
  },

  SET_SLATE(state, slate) {
    state.AllSlate = slate;
  },

  SET_USER_PLAN(state, data) {
    this.state.userModule.userState = data;
  },

  SLATE_STATUS(state, status) {
    state.status = status;
  },

  SET_PLAYER(state, playerDetail) {
    state.playersDetail = playerDetail;
  },

  SET_BUILD_TEAM(state, buildTeam) {
    state.buildTeam = buildTeam;
  },

  SET_PLAYER_SWAP(state, swapData) {
    state.playerSwap = swapData;
  },

  SET_TEAM_STACK(state, teamStack) {
    state.TeamStack = teamStack;
  },

  SET_SAVE_LINEUP(state, lineup) {
    state.savedLineup = lineup;
  },

  SET_LINE_Up_BUILD(state, lineupBuild) {
    state.LineupBuild = lineupBuild;
  },

  SET_TEAM_DETAIL(state, info) {
    state.teamInfo = info;
    // //console.log("teamInfo", typeof state.teamInfo, state.teamInfo);
  },

  SET_RESET_PLAYERS(state, resetData) {
    state.playerReset = resetData;
    // //console.log(state.playerReset);
  },

  SET_PLAYER_PER_TEAM(state, playerPerTeamData) {
    state.playerPerTeam = playerPerTeamData.teamStack.some((element) => {
      return element.minNoOfPlayer > 0;
    });
    //console.log('playerPerTeam', state.playerPerTeam);
  },

  SET_TOP_PLAYERS(state, data) {
    state.TopStudAndValues = data;
    //console.log('top players', state.TopStudAndValues);
  },

  SET_PLAYER_TRENDs(state, data) {
    state.playerTrends = data;
  },

  SET_FULL_STAT(state, data) {
    state.fullStats = data;
  },

  SET_SCORING(state, data) {
    state.scoring = data;
  },

  SET_LAST_LINEUP(state, lineup) {
    state.lastLineup = lineup;
    //console.log('LINEUP res', state.lastLineup);
  },

  SET_MLB_PROPS(state, data) {
    state.mlb_props = data;
  },

  SET_ADP(state, data) {
    state.mlb_adp = data;
  },

  SET_DAILY_LINEUP(state, data) {
    state.daily_lineups = data;
  },

  SET_MLB_NEWS(state, data) {
    state.mlbNews = data;
  },
};

const actions = {
  async getSlate({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await MlbAllTeams.getAllSlate(
        payload || localStorage.getItem("user")
      );
      commit("SET_SLATE", res.data.data);
      commit("SLATE_STATUS", res.data.success);
      if (res.data.success) {
        const notification_1 = {
          type: "success",
          message: "Success",
        };
        dispatch("notification/add", notification_1, { root: true });
        commit("SET_USER_PLAN", res.data.userData);
      }
      commit("SET_LOADING", false);
    } catch (err) {
      const notification = {
        type: "error",
        message: "There was an error with Get All Slates" + err.message,
      };
      dispatch("notification/add", notification, { root: true });
    }
  },

  async getPlayer({ commit }, payload) {
    // cleaning up SET_PLAYER
    commit("SET_PLAYER", []);
    // removing previous slate listener..
    SocketInstance.removeAllListeners(
      `mlbgetPlayers-success-${localStorage.getItem("previousSlate")}`
    );

    try {
      commit("SET_LOADING", true);

      SocketInstance.emit("mlbgetPlayers", payload);
      setTimeout(() => {
        commit("SET_LOADING", false);
      }, 3000);

      // TODO; We have removed News check from backend...
      //? socket listening for response...
      SocketInstance.on(
        `mlbgetPlayers-success-${payload.SlateID}`,
        function (res) {
          console.time("Socket Response");

          if (res.success) {
            commit("SET_PLAYER", res.doc);
          }
          console.timeEnd("Final Socket Response");
        }
      );
    } catch (error) {
      console.error("There was an error with Get MLB Players" + err.message);
    }
  },

  async getTeamDetails({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    await MlbAllTeams.teamDetails(payload)
      .then((res) => {
        //  ;
        commit("SET_TEAM_DETAIL", res.data);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Get Team Details: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async getBuildTeam({ commit, dispatch }, params) {
    commit("SET_BUILD_TEAM_LOADER", true);
    await MlbAllTeams.getTeamBuild(params)
      .then((res) => {
        commit("SET_BUILD_TEAM", res.data);
        commit("SET_BUILD_TEAM_LOADER", false);
        if (res.data.status == 1 || res.data.allTeams.length == 0) {
          const notification = {
            type: "error",
            message: "No Lineup has been created!!",
          };
          return dispatch("notification/add", notification, { root: true });
        } else {
          const notification_1 = {
            type: "success",
            message: "Team has been Created.",
          };
          return dispatch("notification/add", notification_1, { root: true });
        }
      })
      .catch((err) => {
        console.error(err);
        const notification = {
          type: "error",
          message: "There was an error with Get Build Teams",
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async FetchSwapPlayer({ commit }, payload) {
    try {
      const res = await MlbAllTeams.getPlayerSwap(payload);
      commit("SET_PLAYER_SWAP", res.data);
    } catch (err) {
      console.error("There was an error with Get Players swap" + err.message);
    }
  },

  async resetPlayers({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    await MlbAllTeams.resetPlayers(payload)
      .then((res) => {
        commit("SET_RESET_PLAYERS", res.data);
        commit("REMOVE_EXPOSURE");
        commit("SET_LOADING", false);
        const notification = {
          type: "success",
          message: "Player has been reset.",
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Unlock Player:" + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async getSaveLineup({ commit, dispatch }, buildTeam) {
    commit("SET_BUILD_TEAM_LOADER", true);
    try {
      const res = await MlbAllTeams.savedLineup(buildTeam);
      commit("SET_SAVE_LINEUP", res.data.doc);
      commit("SET_BUILD_TEAM_LOADER", false);
      const notification = {
        type: "success",
        message: "Build saved!",
      };
      dispatch("notification/add", notification, { root: true });
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with Get save Lineup.: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  getTeamStack({ commit, dispatch }, slateId) {
    commit("SET_LOADING", true);
    MlbAllTeams.getTeamStack(slateId)
      .then((res) => {
        commit("SET_TEAM_STACK", res.data);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Get Team Stack" + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  getPlayerPerTeam({ commit }, TeamDetails) {
    commit("SET_LOADING", true);
    MlbAllTeams.mlbPlayerPerTeam(TeamDetails)
      .then((response) => {
        commit("SET_PLAYER_PER_TEAM", response.data.result);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Get Player per team." + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async SetExposure({ commit, dispatch }, values) {
    await axios
      .post("https://api.fantasylineups.com/user/setExposure", values)
      .then((res) => {
        if (res.data.success == false) {
          commit("SET_EXPOSURE", res.data.doc);
          const notification = {
            type: "error",
            message: res.data.message,
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          commit("SET_EXPOSURE", res.data.doc);
        }
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error with SetExposure:" + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  async unlockPlayers({ commit, dispatch }, payload) {
    await MlbAllTeams.unlockPlayer(payload)
      .then((res) => {})
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Unlock Player:" + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async getTeams({ commit }) {
    commit("SET_TEAM_LOADER", true);
    try {
      const res = await MlbAllTeams.getAllTeams();
      commit("SET_TEAMS", res.data); //* this will responsible to change the actual state not the action method...
      commit("SET_CLONE", res.data);
      commit("SET_TEAM_LOADER", false);
    } catch (err) {
      return console.error("There was an error with getTeams:" + err.message);
    }
  },

  async getInjuries({ commit }, payload) {
    // commit('SET_TEAM_LOADER', true);
    try {
      const res = await MlbAllTeams.getInjuries(payload);
      commit("SET_INJURIES", res.data); //* this will responsible to change the actual state not the action method...
      // commit('SET_TEAM_LOADER', false);
    } catch (err) {
      return console.error(
        "There was an error with getting Injuries:" + err.message
      );
    }
  },

  async getDepth({ commit }, payload) {
    // commit('SET_TEAM_LOADER', true);
    try {
      const res = await MlbAllTeams.getDepthChart(payload);
      commit("SET_DEPTHCHART", res.data); //* this will responsible to change the actual state not the action method...
      // commit('SET_TEAM_LOADER', false);
    } catch (err) {
      return console.error(
        "There was an error with getting Injuries:" + err.message
      );
    }
  },

  async getUpcomingGames({ commit }, payload) {
    // commit('SET_TEAM_LOADER', true);
    try {
      const res = await MlbAllTeams.getUpcomingGames(payload);
      commit("SET_UPCOMINGGAMES", res.data); //* this will responsible to change the actual state not the action method...
      // commit('SET_TEAM_LOADER', false);
    } catch (err) {
      return console.error(
        "There was an error with getting Injuries:" + err.message
      );
    }
  },

  async SetTopPlays({ commit, dispatch }, payload) {
    try {
      const res = await MlbAllTeams.setTopPlays(payload);
      commit("SET_TOP_PLAYS", res.data);
    } catch (err) {
      const notification = {
        type: "error",
        message: "There was an error with setting up top players" + err.message,
      };
      dispatch("notification/add", notification, { root: true });
    }
  },

  async GetTopPlays({ commit, dispatch }, payload) {
    commit("SET_TOP_PLAYS_LOADER", true);
    try {
      const res = await MlbAllTeams.getTopPlays(payload);
      commit("SHOW_TOP_PLAYS", res.data);
      commit("SET_TOP_PLAYS_LOADER", false);
      const notification = {
        type: "success",
        message: "Player updated successfully.",
      };
      dispatch("notification/add", notification, { root: true });
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with showing up top players" + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPremiumFilterList({ commit, dispatch }, payload) {
    try {
      const res = await MlbAllTeams.getPremiumFilters(payload);
      commit("SHOW_PREMIUM_FILTER", res.data);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message:
          "There was an error with showing up premium filters" + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetTopPlayers({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await MlbAllTeams.getTopPlayers(payload);
      commit("SET_TOP_PLAYERS", res.data);
      commit("SET_LOADING", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with fetching top players: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  FetchPlayerTrends({ commit, dispatch }, payload) {
    commit("SET_TEAM_LOADER", true);
    MlbAllTeams.getPlayerTrend(payload)
      .then((res) => {
        commit("SET_PLAYER_TRENDs", res.data.data);
        commit("SET_TEAM_LOADER", false);
        const notification = {
          type: "success",
          message: "Player trends successfully loaded.",
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error with player trends: " + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  async GetPlayerFullStats({ commit, dispatch }, payload) {
    commit("SET_PLAYERDETAIL_LOADER", true);
    try {
      const res = await MlbAllTeams.getFullStat(payload);
      commit("SET_FULL_STAT", res.data);
      commit("SET_PLAYERDETAIL_LOADER", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with fetching full stats: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPlayerScoring({ commit, dispatch }, payload) {
    try {
      const response = await MlbAllTeams.getPlayerScoring(payload);
      commit("SET_SCORING", response.data);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error Scoring : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  updateSavedLineup({ commit, dispatch }, payload) {
    MlbAllTeams.updateLineup(payload)
      .then((response) => {
        const notification = {
          type: "success",
          message: "Lineup update successfully Mlb.",
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error Scoring : " + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  async SetProjection({ dispatch }, payload) {
    try {
      const res = await common.setProjection(payload);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "Projection update successfully In Nfl.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error set Projection : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  saveLastLineup({ commit }, payload) {
    common
      .saveLastLineup(payload)
      .then((response) => {
        //console.log({ Lastsavedlineup: response.data });
      })
      .catch((err) => {
        console.error("Last lineup save error", err);
      });
  },

  async getLastLineup({ commit }, payload) {
    try {
      const res = await common.fetchLastLineup(payload);
      commit("SET_LAST_LINEUP", res.data);
    } catch (err) {
      console.error("error on fetching last lineup", err);
    }
  },

  async getMlbProps({ commit, dispatch }) {
    try {
      const res = await MlbAllTeams.getMlbProps();
      commit("SET_MLB_PROPS", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "Data fetched successfully In Mlb.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with Mlb_props : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async getADP({ commit, dispatch }) {
    commit("SET_LOADING", true);

    try {
      const res = await MlbAllTeams.getAvgDraftPos();
      commit("SET_ADP", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "ADP Loaded in MLB.",
        };
        dispatch("notification/add", notification, { root: true });
      }
      commit("SET_LOADING", false);
    } catch (error) {
      const notification_1 = {
        type: "error",
        message:
          "There was an error while fetching ADP in MLB : " + error.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async getDailyLineup({ commit, dispatch }) {
    try {
      commit("SET_LOADING", true);
      const res = await MlbAllTeams.getDailyLineups();
      commit("SET_DAILY_LINEUP", res.data);
      commit("SET_LOADING", false);
      if (res.data?.teams.length === 0) {
        const notification = {
          type: "info",
          message: "No Lineups In Mlb Yet.",
        };
        dispatch("notification/add", notification, { root: true });
      } else if (res.data.success) {
        const notification = {
          type: "success",
          message: "Data fetched Successfully Mlb.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with Mlb daily lineup : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async getMlbNews({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      const res = await MlbAllTeams.getMlbNews();
      commit("SET_MLB_NEWS", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "News fetched successfully In Mlb.",
        };
        dispatch("notification/add", notification, { root: true });
      }
      commit("SET_LOADING", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with Mlb daily news : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },
};

const getters = {
  getTeamLoader(state) {
    return state.getTeamStatus;
  },
  loadingStatus(state) {
    return state.loadingStatus;
  },
  buildTeamLoader(state) {
    //console.log('Mlb loader start');
    return state.teamBuildStatus;
  },
  topPlayersLoader(state) {
    return state.topPlaysStatus;
  },
  getSlateID(state) {
    let slateId = state.AllSlate.map((item) => item.SlateID);
    return slateId;
  },

  getStudForDkClsc(state) {
    let studs = [];

    studs.push(
      state.TopStudAndValues.B1_Players,
      state.TopStudAndValues.B2_Players,
      state.TopStudAndValues.B3_Players,
      state.TopStudAndValues.C_Players,
      state.TopStudAndValues.OF_Players,
      state.TopStudAndValues.P_Players,
      state.TopStudAndValues.SS_Players
    );

    let newStuds = studs.map((playerPosition) => {
      // //console.log('playerPosition', _.slice(playerPosition, 0, 3));
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(
      ...newStuds[0],
      ...newStuds[1],
      ...newStuds[2],
      ...newStuds[3],
      ...newStuds[4],
      ...newStuds[5],
      ...newStuds[6]
    );
    return finalStuds;

    // //console.log('studs', studs);
    // //console.log('finalStuds', finalStuds);
  },

  getStudForDkSngl(state) {
    let studs = [];

    studs.push(
      state.TopStudAndValues.CPT_Players,
      state.TopStudAndValues.UTIL_Players
    );

    let newStuds = studs.map((playerPosition) => {
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(...newStuds[0], ...newStuds[1]);
    //console.log('studs', studs);
    //console.log('finalStuds', finalStuds);
    return finalStuds;
  },

  getStudForFdClsc(state) {
    let studs = [];
    let finalStuds = [];

    studs.push(
      state.TopStudAndValues.P_Players,
      state.TopStudAndValues.C1B_Players,
      state.TopStudAndValues.OF_Players,
      state.TopStudAndValues.SS_Players,
      state.TopStudAndValues.B2_Players,
      state.TopStudAndValues.B3_Players,
      state.TopStudAndValues.UTIL_Players
    );

    let newStuds = studs.map((playerPosition) => {
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    finalStuds.push(
      ...newStuds[0],
      ...newStuds[1],
      ...newStuds[2],
      ...newStuds[3],
      ...newStuds[4],
      ...newStuds[5],
      ...newStuds[6]
    );
    //console.log('studs', studs);
    //console.log('finalStuds', finalStuds);

    finalStuds = _.uniqBy(finalStuds, "Name");
    return finalStuds;
  },

  getStudForFdSngl(state) {
    let studs = [];

    studs.push(state.TopStudAndValues.MVP_Players);

    let newStuds = studs.map((playerPosition) => {
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(...newStuds[0]);
    finalStuds = _.uniqBy(finalStuds, "Name");
    return finalStuds;
  },

  NewgetStuds(state, getters) {
    //  ;
    let operator = localStorage.getItem("gameOperator");
    let gameType = localStorage.getItem("gameType");
    if (state.TopStudAndValues) {
      if (operator == "DraftKings" && gameType == "Classic") {
        //console.log('$', operator, gameType);
        return getters.getStudForDkClsc;
      } else if (operator == "DraftKings" && gameType == "Single") {
        return getters.getStudForDkSngl;
      } else if (operator == "FanDuel" && gameType == "Classic") {
        return getters.getStudForFdClsc;
      } else if (operator == "FanDuel" && gameType == "Single") {
        return getters.getStudForFdSngl;
      }
    } else return;
  },

  getValue(state) {
    let values = state.playersDetail.filter(
      (player) =>
        parseInt(player.FPPDdraftking) < 550 &&
        parseInt(player.FPPDfanduel) < 550
    );
    console.log("values mlb", values);
    return values;
  },

  // ? filter by position...
  getFilterBySingle: (state) => (val) => {
    let filterPlayer = [];
    if (val == "CPT") {
      val = "CPT";
      state.position = "1";
    } else if (val == "UTIL") {
      val = "UTIL";
      state.position = "2";
    } else if (val == "Lck/Exl") {
      filterPlayer = state.playersDetail.filter(
        (_players) =>
          _players.type.includes("lock") || _players.type.includes("exclude")
      );
      return filterPlayer;
    }

    filterPlayer = state.playersDetail.filter((item) => {
      // //console.log("item", item.OperatorRosterSlots);
      return item.OperatorRosterSlots == val;
    });
    return filterPlayer;
  },

  getFilterByPositionInFanduel: (state) => (val) => {
    let filterPlayers = [];
    if (val == "MVP") {
      state.position = "1";
      return (filterPlayers = state.playersDetail);
    } else if (val == "STAR") {
      state.position = "2";
      return (filterPlayers = state.playersDetail);
    } else if (val == "UTIL") {
      state.position = "3";
      return (filterPlayers = state.playersDetail);
    } else if (val == "UTIL2") {
      state.position = "4";
      return (filterPlayers = state.playersDetail);
    } else if (val == "UTIL3") {
      state.position = "5";
      return (filterPlayers = state.playersDetail);
    } else if (val == "Lck/Exl") {
      filterPlayers = state.playersDetail.filter(
        (_players) =>
          _players.type.includes("lock") || _players.type.includes("exclude")
      );
      return filterPlayers;
    }

    filterPlayers = state.playersDetail.filter((item) => {
      return item.FanDuelPosition == val;
    });
    return filterPlayers;
  },

  getFilterByPosition: (state) => (val) => {
    let filterPlayer = [];
    if (val.includes("C")) {
      val = "C";
    } else if (val.includes("1B")) {
      val = "1B";
    } else if (val.includes("2B")) {
      val = "2B";
    } else if (val.includes("3B")) {
      val = "3B";
    } else if (val.includes("SS")) {
      val = "SS";
    } else if (val.includes("OF")) {
      val = "OF";
    } else if (val.includes("P")) {
      val = "P";
    } else if (val === "UTIL") {
      val = "UTIL";
      // filterPlayer = state.playersDetail.filter((item) => {
      //   return item.FanDuelPosition !== 'P';
      // });
      // return filterPlayer;
    } else if (val == "Lck/Exl") {
      filterPlayer = state.playersDetail.filter(
        (_players) =>
          _players.type.includes("lock") || _players.type.includes("exclude")
      );
      return filterPlayer;
    }

    filterPlayer = state.playersDetail.filter((item) => {
      if (state.operator == "DraftKings" && item.DraftKingsPosition !== null) {
        return item.Slots.includes(val);
        // return item.DraftKingsPosition.includes(val);
      } else if (state.operator == "FanDuel" && item.FanDuelPosition !== null) {
        if (val.includes("C")) {
          val = "C/1B";
        } else if (val.includes("1B")) {
          val = "C/1B";
        }
        return item.Slots.includes(val);
        // return item.FanDuelPosition.includes(val);
      }
    });
    return filterPlayer;
  },
  getFilterADP: (state) => (val) => {
    let filterPlayers = [];
    if (val.includes("C")) {
      filterPlayers = state.mlb_adp?.players.filter((_player) => {
        return _player.Position === "C";
      });
      return filterPlayers;
    } else if (val.includes("1B")) {
      val = "1B";
    } else if (val.includes("2B")) {
      val = "2B";
    } else if (val.includes("3B")) {
      val = "3B";
    } else if (val.includes("SS")) {
      val = "SS";
    } else if (val.includes("F")) {
      val = "F";
    } else if (val.includes("P")) {
      val = "P";
    } else {
      filterPlayers = state.mlb_adp?.players;
      return filterPlayers;
    }

    filterPlayers = state.mlb_adp?.players.filter((_player) => {
      return _player.Position.includes(val);
    });
    return filterPlayers;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
